export interface User {
  id: number
  email: string
  username: string
  role: string
  is_active: boolean
  is_superuser: boolean
  created_at: string
  updated_at: string
}

export interface AuthState {
  user: Nullable<User>
  token: Nullable<string>
  isLoading: boolean
  error: Nullable<string>
}

export interface LoginCredentials {
  email: string
  password: string
  rememberMe?: boolean
}

export interface RegisterCredentials {
  name: string
  email: string
  password: string
  confirmPassword: string
}

export interface AuthResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
}

export interface LoginErrorResponse {
  detail: string
}

export interface ApiError {
  message: string
  status: number
  code?: string
  errors?: Record<string, string[]>
}

export interface AuthContextType extends AuthState {
  login: (credentials: LoginCredentials) => Promise<void>
  register: (credentials: RegisterCredentials) => Promise<void>
  logout: () => void
  refreshToken: () => Promise<void>
  clearError: () => void
  setAuthenticated: (user: User, token: string) => void
  isAuthenticated: () => boolean
}

// Local storage keys
export const AUTH_STORAGE_KEYS = {
  TOKEN: 'auth_token',
  REFRESH_TOKEN: 'auth_refresh_token',
  USER: 'auth_user',
} as const
